<template>
  <div>
    <PrmSkeleton
      v-if="item.loading"
      class="qmulus-breadcrumb-item__loading"
    />
    <component
      :is="isNullish(item.route) ? 'span' : 'router-link'"
      v-else
      :to="item.route ?? undefined"
      :class="{
        'qmulus-breadcrumb-item__route': !isNullish(item.route),
      }"
      class="flex-row-union flex-align-items_center"
      :data-qa="item.dataQa"
    >
      <template v-if="!isNullish(item.icon)">
        <i
          v-if="typeof item.icon === 'string'"
          :class="item.icon"
        />
        <component
          :is="item.icon"
          v-else
          class="qmulus-breadcrumb-item__component-icon"
        />
      </template>
      {{ item.label }}
    </component>
  </div>
</template>

<script setup lang="ts">
import PrmSkeleton from '@NitrexGroup/primevue/skeleton';

import {
  isNullish,
} from '../../utils/common.ts';

import {
  TBreadcrumbItem,
} from './qmulus-breadcrumb.ts';

defineProps<{
  item: TBreadcrumbItem,
}>();
</script>

<style scoped lang="scss">
$font-size: 1.5rem;

.qmulus-breadcrumb-item {
  &__loading {
    // !important is required to overrule the inline style on the PrmSkeleton
    width: 10rem !important;
    height: $font-size !important;
  }

  &__route {
    color: var(--primary-color);
  }

  &__component-icon {
    height: $font-size;
  }
}
</style>
